import { useMutation, useQueryClient } from 'react-query';

import { IntegrationType } from 'src/generated/mloop-graphql';

import { putIntegration } from './integrationPut';
import { QUERY_KEY } from './types';

const INTEGRATION_TYPE: IntegrationType = IntegrationType.SmartRecruiters;

function putSmartRecruitersIntegration(apiKey: string | undefined, active: boolean) {
  return putIntegration({
    integration_type: INTEGRATION_TYPE,
    smartRecruiters: {
      api_key: apiKey,
      active,
    },
  });
}

export default function useSmartRecruitersIntegrationPut() {
  const queryClient = useQueryClient();
  return useMutation(
    (data: { apiKey?: string; active: boolean }) => putSmartRecruitersIntegration(data.apiKey, data.active),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QUERY_KEY]);
        queryClient.invalidateQueries([QUERY_KEY, INTEGRATION_TYPE]);
      },
    }
  );
}
